'use client';

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Stack,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";

const AdminBookingsList = () => {
  const [bookings, setBookings] = useState([]);
  const [allBookings, setAllBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterDate, setFilterDate] = useState("");

  // Fetch bookings
  const fetchBookings = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_BOOKING_API_URL}`);
      const data = await res.json();
      if (data.success) {
        setBookings(data.bookings);
        setAllBookings(data.bookings);
      }
    } catch (err) {
      console.error("Failed to fetch bookings:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  // Delete booking
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this booking?")) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_BOOKING_API_URL}?id=${id}`, {
        method: "DELETE",
      });
      const data = await res.json();
      console.log(data);
      if (data.success) {
        setBookings(prev => prev.filter(b => b.id !== id));
        setAllBookings(prev => prev.filter(b => b.id !== id));
      }
      alert("deleted successfuly");
    } catch (err) {
      console.error(err);
    }
  };

  // Filter
  const handleFilter = () => {
    if (!filterDate) {
      setBookings(allBookings);
      return;
    }
    setBookings(
      allBookings.filter(
        b => dayjs(b.date).format("YYYY-MM-DD") === filterDate
      )
    );
  };

  const handleReset = () => {
    setFilterDate("");
    setBookings(allBookings);
  };

  return (
    <Box sx={{ p: 3, mt: "80px", minHeight: "100vh", backgroundColor: "#0d1b3f" }}>
      <Typography variant="h4" mb={3} fontWeight={600} color="#fff">
        Bookings List
      </Typography>

      {/* Filters */}
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={3}>
        <TextField
          type="date"
          label="Filter by Date"
          InputLabelProps={{ shrink: true }}
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
          sx={{
            input: { color: "#fff" },
            label: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#fff" },
              "&:hover fieldset": { borderColor: "#90caf9" },
              "&.Mui-focused fieldset": { borderColor: "#90caf9" },
            },
          }}
        />
        <Button variant="contained" onClick={handleFilter}>
          Filter
        </Button>
        <Button variant="outlined" onClick={handleReset} sx={{ color: "#fff" }}>
          Reset
        </Button>
      </Stack>

      {/* Table */}
      <TableContainer component={Paper} sx={{ backgroundColor: "#1e2a4a" }}>
        <Table>
          <TableHead>
            <TableRow>
              {["Name", "Phone", "Service", "Purpose", "Date", "Time", "Action"].map(
                (head) => (
                  <TableCell key={head} sx={{ color: "#90caf9", fontWeight: 600 }}>
                    {head}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} sx={{ color: "#fff" }}>
                  Loading...
                </TableCell>
              </TableRow>
            ) : bookings.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} sx={{ color: "#fff" }}>
                  No bookings found
                </TableCell>
              </TableRow>
            ) : (
              bookings.map((booking) => (
                <TableRow key={booking.id}>
                  <TableCell sx={{ color: "#fff" }}>{booking.name}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>{booking.phone}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>{booking.service}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>
                    {booking.purpose || "-"}
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>
                    {dayjs(booking.date).format("DD MMM YYYY")}
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>{booking.timeslot}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => handleDelete(booking.id)}
                      sx={{ color: "#ff6b6b" }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AdminBookingsList;
